var _defs, _g, _a;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlideDecsPhase5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 428.24 443.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-slide-decs-p5 {\n        fill: #e61e25;\n      }\n\n      .cls-1-slide-decs-p5, .cls-2-slide-decs-p5, .cls-3-slide-decs-p5, .cls-4-slide-decs-p5, .cls-5-slide-decs-p5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2-slide-decs-p5 {\n        fill: #edeef0;\n        pointer-events: none;\n      }\n\n    \n      .cls-3-slide-decs-p5, .cls-6-slide-decs-p5 {\n        fill: none;\n      }\n\n      .cls-7-slide-decs-p5, .cls-4-slide-decs-p5 {\n        fill: #edeef0;\n        pointer-events: none;\n      }\n\n      .cls-7-slide-decs-p5, .cls-8-slide-decs-p5, .cls-6-slide-decs-p5, .cls-9-slide-decs-p5 {\n        stroke: #e87203;\n      }\n\n      .cls-8-slide-decs-p5, .cls-9-slide-decs-p5 {\n        fill: #e87203;\n      }\n\n      .cls-5-slide-decs-p5 {\n        fill: #3a414a;\n      }\n\n      .cls-9-slide-decs-p5 {\n        stroke-width: .05px;\n      }\n\n      .cls-10-slide-decs-p5 {\n        fill: #273777;\n        stroke: #273777;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6-slide-decs-p5",
    d: "M255.64,100.17v52.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9-slide-decs-p5",
    d: "M256.14,100.18h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-slide-decs-p5",
    d: "M255.64,167.86l-4.62-14.27h9.27l-4.65,14.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7-slide-decs-p5",
    d: "M83.54,6.5c0-3.31,2.69-6,6-6h332.2c3.31,0,6,2.69,6,6h0v86.67c0,3.31-2.69,6-6,6H89.54c-3.31,0-6-2.69-6-6h0V6.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "p",
    className: "cls-5-slide-decs-p5",
    d: "M116.85,38.97h-2.72l-3.8-14.26-3.73,14.26h-2.72l-4.96-16.84h2.38l4.01,14.8,1.02-4.35,2.92-10.46h2.17l4.01,14.8,4.01-14.8h2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    className: "cls-5-slide-decs-p5",
    d: "M123.43,23.28v-2.04h2.17v2.04h-2.17ZM123.43,38.97v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    className: "cls-5-slide-decs-p5",
    d: "M131.17,35.77c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    className: "cls-5-slide-decs-p5",
    d: "M141.16,27.49c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    className: "cls-5-slide-decs-p5",
    d: "M153.31,25.79c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM153.92,27.42c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "cls-5-slide-decs-p5",
    d: "M168.86,27.9c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    className: "cls-5-slide-decs-p5",
    d: "M178.77,36.52c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM172.46,35.37c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    className: "cls-5-slide-decs-p5",
    d: "M196.77,38.97h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "v-2",
    "data-name": "v",
    className: "cls-5-slide-decs-p5",
    d: "M216.73,36.52c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM210.41,35.37c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    className: "cls-5-slide-decs-p5",
    d: "M229.9,29.26c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-2",
    "data-name": "x",
    className: "cls-5-slide-decs-p5",
    d: "M242.12,29.26c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "cls-5-slide-decs-p5",
    d: "M251.97,25.79c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM251.9,37.61c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z",
    className: "cls-5-slide-decs-p5",
    d: "M265.28,27.49c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-2",
    "data-name": "q",
    className: "cls-5-slide-decs-p5",
    d: "M272.61,23.28v-2.04h2.17v2.04h-2.17ZM272.61,38.97v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-3",
    "data-name": "v",
    className: "cls-5-slide-decs-p5",
    d: "M285.92,36.52c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM279.61,35.37c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r-2",
    "data-name": "r",
    className: "cls-5-slide-decs-p5",
    d: "M293.93,35.77c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    className: "cls-5-slide-decs-p5",
    d: "M303.51,25.79c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM307.04,31.29c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-2",
    "data-name": "t",
    className: "cls-5-slide-decs-p5",
    d: "M316.07,25.79c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM316.68,27.42c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "B",
    className: "cls-5-slide-decs-p5",
    d: "M341.53,30.07c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM334.95,29.32c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM334.95,37.13c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-2",
    "data-name": "u",
    className: "cls-5-slide-decs-p5",
    d: "M354.71,27.9c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-3",
    "data-name": "q",
    className: "cls-5-slide-decs-p5",
    d: "M356.67,23.28v-2.04h2.17v2.04h-2.17ZM356.67,38.97v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-2",
    "data-name": "A",
    className: "cls-5-slide-decs-p5",
    d: "M367.2,25.79c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM370.73,31.29c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    className: "cls-5-slide-decs-p5",
    d: "M380.85,23.08c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-4",
    "data-name": "q",
    className: "cls-5-slide-decs-p5",
    d: "M382.41,23.28v-2.04h2.17v2.04h-2.17ZM382.41,38.97v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    className: "cls-5-slide-decs-p5",
    d: "M394.09,25.79c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    className: "cls-5-slide-decs-p5",
    d: "M411.74,26.07c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM406.11,37.47c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "F",
    className: "cls-5-slide-decs-p5",
    d: "M233.2,68.57c-5.57,0-8.22-3.26-8.49-8.76-.34-7.27,6.79-10.46,13.1-7.54,1.15.54,1.97,1.7,2.51,2.92l-2.17.61c-.88-1.7-2.51-2.72-5.16-2.72-4.14,0-5.98,2.65-5.98,6.72s1.97,6.79,6.18,6.86c2.38,0,4.21-.75,5.36-1.83v-3.06h-5.02v-1.9h7.13v5.84c-1.7,1.7-4.14,2.85-7.47,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    className: "cls-5-slide-decs-p5",
    d: "M248.2,68.57c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-5",
    "data-name": "q",
    className: "cls-5-slide-decs-p5",
    d: "M257.71,52.61v-2.04h2.17v2.04h-2.17ZM257.71,68.3v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-3",
    "data-name": "t",
    className: "cls-5-slide-decs-p5",
    d: "M267.21,55.13c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM267.83,56.76c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-3",
    "data-name": "A",
    className: "cls-5-slide-decs-p5",
    d: "M281.81,55.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM285.34,60.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7-slide-decs-p5",
    d: "M83.54,175.97c0-3.31,2.69-6,6-6h332.2c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H89.54c-3.31,0-6-2.69-6-6v-86.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "H",
    className: "cls-5-slide-decs-p5",
    d: "M117.46,212.29c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-4",
    "data-name": "A",
    className: "cls-5-slide-decs-p5",
    d: "M127.98,211.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM131.51,217.45c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D-2",
    "data-name": "D",
    className: "cls-5-slide-decs-p5",
    d: "M142.72,211.95c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-4",
    "data-name": "t",
    className: "cls-5-slide-decs-p5",
    d: "M154.12,211.95c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM154.74,213.58c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "w-2",
    "data-name": "w",
    className: "cls-5-slide-decs-p5",
    d: "M182.71,225.12h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-6",
    "data-name": "q",
    className: "cls-5-slide-decs-p5",
    d: "M187.94,209.44v-2.04h2.17v2.04h-2.17ZM187.94,225.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r-3",
    "data-name": "r",
    className: "cls-5-slide-decs-p5",
    d: "M195.68,221.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s-2",
    "data-name": "s",
    className: "cls-5-slide-decs-p5",
    d: "M205.66,213.65c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-5",
    "data-name": "t",
    className: "cls-5-slide-decs-p5",
    d: "M217.82,211.95c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM218.43,213.58c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-3",
    "data-name": "u",
    className: "cls-5-slide-decs-p5",
    d: "M233.37,214.06c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-4",
    "data-name": "v",
    className: "cls-5-slide-decs-p5",
    d: "M243.28,222.68c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM236.96,221.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-3",
    "data-name": "w",
    className: "cls-5-slide-decs-p5",
    d: "M261.27,225.12h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-5",
    "data-name": "v",
    className: "cls-5-slide-decs-p5",
    d: "M274.45,222.68c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM268.13,221.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    className: "cls-5-slide-decs-p5",
    d: "M280.08,225.12v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "D-3",
    "data-name": "D",
    className: "cls-5-slide-decs-p5",
    d: "M298.55,211.95c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-2",
    "data-name": "y",
    className: "cls-5-slide-decs-p5",
    d: "M310.98,211.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM310.91,223.77c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r-4",
    "data-name": "r",
    className: "cls-5-slide-decs-p5",
    d: "M321.77,221.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-7",
    "data-name": "q",
    className: "cls-5-slide-decs-p5",
    d: "M326.19,209.44v-2.04h2.17v2.04h-2.17ZM326.19,225.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-2",
    "data-name": "C",
    className: "cls-5-slide-decs-p5",
    d: "M336.78,209.23c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-8",
    "data-name": "q",
    className: "cls-5-slide-decs-p5",
    d: "M338.34,209.44v-2.04h2.17v2.04h-2.17ZM338.34,225.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z-2",
    "data-name": "z",
    className: "cls-5-slide-decs-p5",
    d: "M348.59,213.65c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-6",
    "data-name": "v",
    className: "cls-5-slide-decs-p5",
    d: "M363.87,222.68c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM357.56,221.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r-5",
    "data-name": "r",
    className: "cls-5-slide-decs-p5",
    d: "M371.88,221.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-9",
    "data-name": "q",
    className: "cls-5-slide-decs-p5",
    d: "M376.3,209.44v-2.04h2.17v2.04h-2.17ZM376.3,225.12v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-3",
    "data-name": "y",
    className: "cls-5-slide-decs-p5",
    d: "M386.82,211.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM386.75,223.77c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D-4",
    "data-name": "D",
    className: "cls-5-slide-decs-p5",
    d: "M401.56,211.95c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7-slide-decs-p5",
    d: "M83.54,350.05c0-3.31,2.69-6,6-6h332.2c3.31,0,6,2.69,6,6v86.65c0,3.31-2.69,6-6,6H89.54c-3.31,0-6-2.69-6-6h0v-86.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "J",
    className: "cls-5-slide-decs-p5",
    d: "M106.7,382.51h-2.31l-6.86-16.84h2.38l5.64,14.8,5.64-14.8h2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-5",
    "data-name": "A",
    className: "cls-5-slide-decs-p5",
    d: "M119.12,369.34c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM122.65,374.84c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-6",
    "data-name": "A",
    className: "cls-5-slide-decs-p5",
    d: "M132.7,369.34c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM136.23,374.84c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K",
    className: "cls-5-slide-decs-p5",
    d: "M146.83,382.51h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-7",
    "data-name": "v",
    className: "cls-5-slide-decs-p5",
    d: "M161.29,380.06c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM154.97,378.91c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "L",
    className: "cls-5-slide-decs-p5",
    d: "M186.48,370.35c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-4",
    "data-name": "y",
    className: "cls-5-slide-decs-p5",
    d: "M196.46,369.34c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM196.39,381.15c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-5",
    "data-name": "y",
    className: "cls-5-slide-decs-p5",
    d: "M210.04,369.34c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM209.97,381.15c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-4",
    "data-name": "u",
    className: "cls-5-slide-decs-p5",
    d: "M224.57,371.44c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-6",
    "data-name": "t",
    className: "cls-5-slide-decs-p5",
    d: "M230.68,369.34c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM231.29,370.97c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-10",
    "data-name": "q",
    className: "cls-5-slide-decs-p5",
    d: "M240.12,366.82v-2.04h2.17v2.04h-2.17ZM240.12,382.51v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D-5",
    "data-name": "D",
    className: "cls-5-slide-decs-p5",
    d: "M251.8,369.34c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-8",
    "data-name": "v",
    className: "cls-5-slide-decs-p5",
    d: "M267.01,380.06c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM260.7,378.91c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r-6",
    "data-name": "r",
    className: "cls-5-slide-decs-p5",
    d: "M275.02,379.32c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-6",
    "data-name": "y",
    className: "cls-5-slide-decs-p5",
    d: "M284.6,369.34c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM284.53,381.15c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-5",
    "data-name": "u",
    className: "cls-5-slide-decs-p5",
    d: "M299.13,371.44c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "u-6",
    "data-name": "u",
    className: "cls-5-slide-decs-p5",
    d: "M314,371.44c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-7",
    "data-name": "A",
    className: "cls-5-slide-decs-p5",
    d: "M321.13,369.34c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM324.66,374.84c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r-7",
    "data-name": "r",
    className: "cls-5-slide-decs-p5",
    d: "M331.92,379.32c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-11",
    "data-name": "q",
    className: "cls-5-slide-decs-p5",
    d: "M336.34,366.82v-2.04h2.17v2.04h-2.17ZM336.34,382.51v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-7",
    "data-name": "u",
    className: "cls-5-slide-decs-p5",
    d: "M347.81,371.44c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-8",
    "data-name": "A",
    className: "cls-5-slide-decs-p5",
    d: "M354.94,369.34c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM358.47,374.84c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-3",
    "data-name": "x",
    className: "cls-5-slide-decs-p5",
    d: "M370.9,372.8c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "r-8",
    "data-name": "r",
    className: "cls-5-slide-decs-p5",
    d: "M384.75,379.32c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s-3",
    "data-name": "s",
    className: "cls-5-slide-decs-p5",
    d: "M394.73,371.03c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-9",
    "data-name": "A",
    className: "cls-5-slide-decs-p5",
    d: "M407.91,369.34c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM411.44,374.84c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "M",
    className: "cls-5-slide-decs-p5",
    d: "M176.12,400.37c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-9",
    "data-name": "v",
    className: "cls-5-slide-decs-p5",
    d: "M191.74,409.4c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM185.43,408.24c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r-9",
    "data-name": "r",
    className: "cls-5-slide-decs-p5",
    d: "M199.75,408.65c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A-10",
    "data-name": "A",
    className: "cls-5-slide-decs-p5",
    d: "M209.33,398.67c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM212.86,404.17c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-8",
    "data-name": "u",
    className: "cls-5-slide-decs-p5",
    d: "M223.86,400.77c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q-12",
    "data-name": "q",
    className: "cls-5-slide-decs-p5",
    d: "M225.83,396.16v-2.04h2.17v2.04h-2.17ZM225.83,411.84v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-10",
    "data-name": "v",
    className: "cls-5-slide-decs-p5",
    d: "M239.14,409.4c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM232.82,408.24c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I-2",
    "data-name": "I",
    className: "cls-5-slide-decs-p5",
    d: "M244.77,411.84v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "q-13",
    "data-name": "q",
    className: "cls-5-slide-decs-p5",
    d: "M256.93,396.16v-2.04h2.17v2.04h-2.17ZM256.93,411.84v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D-6",
    "data-name": "D",
    className: "cls-5-slide-decs-p5",
    d: "M268.61,398.67c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "J-2",
    "data-name": "J",
    className: "cls-5-slide-decs-p5",
    d: "M290.33,411.84h-2.31l-6.86-16.84h2.38l5.64,14.8,5.64-14.8h2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J-3",
    "data-name": "J",
    className: "cls-5-slide-decs-p5",
    d: "M306.63,411.84h-2.31l-6.86-16.84h2.38l5.64,14.8,5.64-14.8h2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    className: "cls-5-slide-decs-p5",
    d: "M315.66,395c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM317.9,403.49c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "cls-5-slide-decs-p5",
    d: "M346.22,411.84l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-slide-decs-p5",
    d: "M255.64,269.64v57.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9-slide-decs-p5",
    d: "M256.14,269.65h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-slide-decs-p5",
    d: "M255.64,341.93l-4.62-14.27h9.27l-4.65,14.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-slide-decs-p5",
    d: "M11.24,32.3h66.92v35.1H11.23v-35.1Z"
  }))), _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "#popup_flight_travlDil50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10-slide-decs-p5",
    d: "M5.01,36.05h64.1v33.6H5.01v-33.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-slide-decs-p5",
    d: "M73.37,37.82L4.65,72.45l-2.3-4.56,68.72-34.63s2.3,4.56,2.3,4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p5",
    d: "M72.25,35.75L3.53,70.39l-.68-1.35,68.72-34.63.68,1.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-slide-decs-p5",
    d: "M70.11,72.45L1.68,37.25l2.34-4.55,68.43,35.2-2.34,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p5",
    d: "M43.91,57.43L1.68,35.7l.63-1.22,42.23,21.73s-.63,1.22-.63,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p5",
    d: "M71.17,69.95l-24.66-12.7.67-1.28,24.65,12.68s-.66,1.3-.66,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-slide-decs-p5",
    d: "M2.81,48.28h69.02v9.15H2.83l-.02-9.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-slide-decs-p5",
    d: "M41.64,34.35v36.2h-9.16v-36.2h9.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p5",
    d: "M2.81,49.75h69.02v6.22H2.83l-.02-6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-slide-decs-p5",
    d: "M40.25,35.54v34.85h-6.37v-34.85h6.37Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-slide-decs-p5",
    y: 30.75,
    width: 74.55,
    height: 4.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-slide-decs-p5",
    x: 0.15,
    y: 30.79,
    width: 4.36,
    height: 42.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-slide-decs-p5",
    x: 0.15,
    y: 70.1,
    width: 75.3,
    height: 5.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-slide-decs-p5",
    x: 69.68,
    y: 30.75,
    width: 5.51,
    height: 45.28
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideDecsPhase5);
export default __webpack_public_path__ + "static/media/Slide_Decs_Phase_5.2e4258dea79ba60e0af06e1de561627c.svg";
export { ForwardRef as ReactComponent };